import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Building2 } from 'lucide-react';
import { createPageUrl } from '../../utils';
import ModuleSwitcher from './ModuleSwitcher';
import NotificationsDropdown from './NotificationsDropdown';
import UserMenu from './UserMenu';

interface HeaderProps {
  activeModule: string;
  notifications: any[];
  user: any;
  onMenuClick: () => void;
  onLogout: () => void;
}

export default function Header({
  activeModule,
  notifications,
  user,
  onMenuClick,
  onLogout,
}: HeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-[#1e3a5f] text-white z-50 flex items-center justify-between px-4 shadow-lg">
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuClick}
          className="p-2 hover:bg-white/10 rounded-lg transition-colors"
        >
          <Menu className="w-5 h-5" />
        </button>
        <Link to={createPageUrl('Portal')} className="flex items-center gap-3">
          <div className="w-8 h-8 bg-[#c9a227] rounded-lg flex items-center justify-center">
            <Building2 className="w-5 h-5 text-white" />
          </div>
          <span className="font-semibold text-lg hidden sm:block">Bank Modular System</span>
        </Link>
      </div>

      <div className="flex items-center gap-2">
        <ModuleSwitcher activeModule={activeModule} />
        <NotificationsDropdown notifications={notifications} />
        <UserMenu user={user} onLogout={onLogout} />
      </div>
    </header>
  );
}
